var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"copyright"},[_vm._v(" Build date: "+_vm._s(_vm.date)+" © "+_vm._s(_vm.year)+" made by "),_c('a',{attrs:{"href":"https://www.synergylabs.org/","target":"_blank","rel":"noopener"}},[_vm._v("Synergy Labs")]),_vm._v(". ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }